import type { ReactElement } from 'react';
import { Card } from '@fastnorth/react-cerberus/Card';
import { useTranslation } from 'react-i18next';

type GeneralErrorProps = {
  error?: Error;
  className?: string;
  title?: string;
  message?: string;
};

const globalVars: any = globalThis;

const GeneralError = ({ error, className, message = '', title = '' }: GeneralErrorProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Card>
      <Card.Body className={`${className} d-flex justify-content-center align-items-center flex-wrap`}>
        <img
          className={'d-inline-block mr-md-4 mb-4 mb-md-0'}
          src={'https://cdn.raceroster.com/assets/cerbicons/empty-500.svg'}
          alt={''}
        />
        <div>
          <h1>{title || t('photos_ui.general_error.title')}</h1>
          <p>{message || t('photos_ui.general_error.message')}</p>
          {error?.message && <p className={'mt-4'}>{error.message}</p>}
          {globalVars.env?.mode == 'development' && error?.stack && (
            <p className={'mt-4'}>
              <code>{error.stack}</code>
            </p>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default GeneralError;
